"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileNav = require("./MobileNav.styles");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DesktopNav = require("../DesktopNav/DesktopNav.style");

var MobileNavHeader = function MobileNavHeader(_ref) {
  var account = _ref.account,
      activeMenuTitle = _ref.activeMenuTitle,
      goBackMenu = _ref.goBackMenu;

  var _account$avatar, _account$avatar$image, _account$avatar$image2;

  return /*#__PURE__*/_react.default.createElement(_MobileNav.MenuHeader, null, /*#__PURE__*/_react.default.createElement(_MobileNav.HeaderItem, {
    onClick: goBackMenu
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "ChevronLeft"
  })), /*#__PURE__*/_react.default.createElement(_MobileNav.HeaderItem, null, account && activeMenuTitle === 'Profile' ? /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_MobileNav.ProfileIcon, {
    size: "small",
    name: account.avatar.name,
    image: {
      src: account === null || account === void 0 ? void 0 : (_account$avatar = account.avatar) === null || _account$avatar === void 0 ? void 0 : (_account$avatar$image = _account$avatar.image) === null || _account$avatar$image === void 0 ? void 0 : (_account$avatar$image2 = _account$avatar$image.fluid) === null || _account$avatar$image2 === void 0 ? void 0 : _account$avatar$image2.src
    }
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLabel, {
    enhanced: true
  }, activeMenuTitle))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLabel, {
    enhanced: true
  }, activeMenuTitle))), /*#__PURE__*/_react.default.createElement(_MobileNav.HeaderItem, null));
};

MobileNavHeader.propTypes = {
  activeMenuTitle: _propTypes.default.string,
  goBackMenu: _propTypes.default.func,

  /** Object defining account area, avatar property is used to control display of the avatar circle, either with image or name, menu is the array of items supplied to the dropdown menu */
  account: _propTypes.default.shape({
    avatar: _propTypes.default.shape({
      image: _propTypes.default.shape({
        /** Fluid image object */
        fluid: _propTypes.default.shape({
          base64: _propTypes.default.string.isRequired,
          aspectRatio: _propTypes.default.number.isRequired,
          src: _propTypes.default.string.isRequired,
          srcSet: _propTypes.default.string.isRequired,
          srcSetWebp: _propTypes.default.string.isRequired,
          sizes: _propTypes.default.string.isRequired
        }),

        /** File src of image object in case we dont have a fluid obj */
        src: _propTypes.default.string
      }),
      name: _propTypes.default.string
    }),
    menu: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      onClick: _propTypes.default.func,
      url: _propTypes.default.string
    }))
  })
};
MobileNavHeader.defaultProps = {
  account: null,
  activeMenuTitle: 'Menu',
  goBackMenu: function goBackMenu() {}
};
var _default = MobileNavHeader;
exports.default = _default;